import { type SvgProps, SvgWrapper } from '../utils';
export function LagmannsrettIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <rect x="4" y="10" width="15.65" height="3.9125" />
    </SvgWrapper>
  );
}
